import {useMemo} from 'react';

import {DateRange} from 'src/components/filter-header/typedefs';
import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';
import {filterDataByPredicates} from 'src/utils/filterDataByPredicates';

export type FilterValue = string[] | DateRange;

export const useFilteredData = <T, F>(
    data: Array<T>,
    filters: F,
    createPredicates: (filters: F) => FilterPredicate<T>[],
) => {
    return useMemo(() => {
        return filterDataByPredicates(data, filters, createPredicates);
    }, [data, filters, createPredicates]);
};
